"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tuoro-sul-trasimeno": {
    "8572c6c1": [{
      "hkey": "59a16ed6",
      "slug": "tuoro-sul-trasimeno",
      "name": "Tuoro sul Trasimeno",
      "primary": true,
      "skipSearch": false
    }],
    "piazzano": [{
      "hkey": "59a16ed6",
      "slug": "tuoro-sul-trasimeno",
      "name": "Tuoro sul Trasimeno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd0d8a3a": [{
      "hkey": "6346e2b4",
      "slug": "vernazzano-basso",
      "name": "Vernazzano Basso",
      "primary": true,
      "skipSearch": false
    }],
    "vernazzano": [{
      "hkey": "6346e2b4",
      "slug": "vernazzano-basso",
      "name": "Vernazzano Basso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;